<template>
  <swiper :options="swiperOption">
    <swiper-slide class="my-swp-silde" v-for="(slide, key) in value" :key="key" data-id="slide.id">
            <img class="my-swp-img" :src="slide.adPic" alt="">
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'index',
  props: {
    value: Object
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },

  data() {
    return {
      swiperOption: {
        // pagination: { el: '.swiper-pagination' }, // 分页按钮
        autoplay: {
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          delay: 3000 // 自动切换的时间间隔（单位ms）
        }
      },
      iconSwiperOption: {
        pagination: { el: '.swiper-pagination' }
      },
      swiperList: [], // 轮播图数组对象
      iconsList: [] // 图标二维（分页）数组对象
    }
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/MySwiper/index.vue